import { AppZIndexes } from "@app/app/constants/AppZIndexes";
import { wrapAsync } from "@app/common/utils/asyncUtils";

import { HostApiEventData, HostApiEventName } from "./api/events";
import { HostApiMethodCallBack, HostApiMethodName, PrivateApiMethodCallBack, PrivateApiMethodName } from "./api/methods";
import { hostManager } from "./HostManager";

export interface IHostApiValues {
    isInitialized: boolean;
}

export class HostService {
    public constructor() {
        this.registerHostApiFunction("getAppZIndexes", () => AppZIndexes);
    }

    public registerHostApiFunction<T extends HostApiMethodName>(method: T, callback: HostApiMethodCallBack<T>): void {
        hostManager.apiAdapter.registerMethodHandler(method, wrapAsync(callback));
    }

    public registerHostPrivateApiFunction<T extends PrivateApiMethodName>(method: T, callback: PrivateApiMethodCallBack<T>): void {
        hostManager.privateApiAdapter.registerMethodHandler(method, callback);
    }

    public sendHostApiEvent<T extends HostApiEventName>(event: T, data?: HostApiEventData<T>): void {
        hostManager.apiAdapter.sendEventToHost(event, data);
    }

    public setHostApiValue<T extends keyof IHostApiValues>(key: T, value: IHostApiValues[T]): void {
        hostManager.apiAdapter.setValue(key, value);
    }
}

export const hostService = new HostService();
